module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Light.a35e8116.woff2";